import React, { Fragment, Component, useState } from "react";
import PreSales from "./contracts/PreSales3.json";
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import CircularProgress from '@material-ui/core/CircularProgress';
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { IntlProvider } from 'react-intl';
import { SnackbarProvider, useSnackbar } from 'notistack';
import Backdrop from '@material-ui/core/Backdrop';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

import getWeb3 from "./getWeb3";
import getWeb3ByWalletConnect from "./getWeb3ByWalletConnect";
import getWeb3ByIjected from "./getWeb3ByIjected";

import TokenSalesInfo from "./components/TokenSalesInfo";
import TokenSalesHeader from "./components/TokenSalesHeader";
import BuyToken from "./components/BuyToken";
import WithdrawTokens from "./components/WithdrawTokens";
import RefundTokens from "./components/RefundTokens";
import BalanceTokens from "./components/BalanceTokens";
import "./App.css";
import message from "./locales";
import { AppBar, Button, Toolbar } from "@material-ui/core";
import Config from "./config";
import { DialogTitle, Icon, IconButton, List, ListItem, ListItemIcon, ListItemText} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close';
import { FormattedMessage } from 'react-intl'

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  footer: {
    padding: theme.spacing(0, 1),
    margin: theme.spacing(4 ,7),
    display: 'flex',
    flexDirection: 'column',
    alignItems: "flex-end",
    justifyContent: "flex-end",
    "& *": {
      // opacity: 0.5,
      // color: "#e07000"
    }
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  hidden: {
    visibility: "hidden",
  },
  backdrop: {
    zIndex: 99999,
    color: '#fff',
  },
  dialogContent: {
    padding: theme.spacing(2)
  },
  balanceButton: {
    width:'100%'
  },
  connectWalletList: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    "&>div": {
      "&:hover": {
        backgroundColor: '#171a23AA',
      },
      backgroundColor: '#171a23',
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(1),
      borderRadius: '100px'
    },
  }
}));

const Root = () => {
  const classes = useStyles();
  const [accounts, setAccounts] = useState()
  const [config, setConfig] = useState(<div />)
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [backdrop, setBackdrop] = useState(false);
  const [openSalesInfoDialog, setSalesInfoDialog] = useState(false);
  const [openBalanceDialog, setBalanceDialog] = useState(false);
  const [openWithdrawDialog, setWithdrawDialog] = useState(false);
  const [openRefundDialog, setRefundDialog] = useState(false);
  const [openConnect, setOpenConnect] = useState(false)

  const [sales, setSales] = useState()
  const [readSales, setReadSales] = useState()

  const initReader = async () => {
    if (!readSales) {
      const Contract = require('web3-eth-contract');
      Contract.setProvider(process.env.REACT_APP_READ_PROVIDER);
      const networkId = process.env.REACT_APP_NETWORK_ID
      const _config = Config(networkId)
      setConfig(_config)

      const deployedNetwork = PreSales.networks[networkId];
      const _instance = new Contract(
        PreSales.abi,
        deployedNetwork && deployedNetwork.address,
      );
      setReadSales(_instance)
    }
  }
  const handleClose = () => {
    setSalesInfoDialog(false);
    setBalanceDialog(false);
    setWithdrawDialog(false);
    setRefundDialog(false);
  };
  const connectWeb3ByWalletConnect = async () => {
    try {
      const web3 = await getWeb3ByWalletConnect();
      setBackdrop(true)
      if ((await web3.eth.net.getId()).toString() !== process.env.REACT_APP_NETWORK_ID) {
        enqueueSnackbar("Connect error \nDo the following\n■PC :\nDownload a wallet such as Metamask\n■Smartphone :\nDownload the wallet's\n smartphone app > Open the app >\n Open eartha.org via the browser in the app >\n Click on the \"Buy\" button", {
          variant: 'error',
          persist: true,
          style: { whiteSpace: 'pre-line' },
          action: key => (
            <Fragment>
              <IconButton onClick={() => { closeSnackbar(key) }}>
                <CloseIcon />
              </IconButton>
            </Fragment>
          )
        })
        setBackdrop(false)
        return
      }
      const _accounts = await web3.eth.getAccounts();

      const networkId = await web3.eth.net.getId();
      const deployedNetwork = PreSales.networks[networkId];
      const _instance = new web3.eth.Contract(
        PreSales.abi,
        deployedNetwork && deployedNetwork.address,
      );

      setAccounts(_accounts)
      setSales(_instance)
      onConnectClose()
      enqueueSnackbar("Connect", { variant: 'success' })
    } catch (error) {
      console.log(error)
    }
    setBackdrop(false)
  }
  const connectWeb3ByIjected = async () => {
    try {
      const web3 = await getWeb3ByIjected();
      setBackdrop(true)
      if ((await web3.eth.net.getId()).toString() !== process.env.REACT_APP_NETWORK_ID) {
        enqueueSnackbar("Connect error \nDo the following\n■PC :\nDownload a wallet such as Metamask\n■Smartphone :\nDownload the wallet's\n smartphone app > Open the app >\n Open eartha.org via the browser in the app >\n Click on the \"Buy\" button", {
          variant: 'error',
          persist: true,
          style: { whiteSpace: 'pre-line' },
          action: key => (
            <Fragment>
              <IconButton onClick={() => { closeSnackbar(key) }}>
                <CloseIcon />
              </IconButton>
            </Fragment>
          )
        })
        setBackdrop(false)
        return
      }
      const _accounts = await web3.eth.getAccounts();

      const networkId = await web3.eth.net.getId();
      const deployedNetwork = PreSales.networks[networkId];
      const _instance = new web3.eth.Contract(
        PreSales.abi,
        deployedNetwork && deployedNetwork.address,
      );

      setAccounts(_accounts)
      setSales(_instance)
      onConnectClose()
      enqueueSnackbar("Connect", { variant: 'success' })
    } catch (error) {
      console.log(error)
    }
    setBackdrop(false)
  }
  const connectWeb3ByMetaMask = async () => {
    try {
      setBackdrop(true)
      const web3 = await getWeb3();
      if (window.ethereum.networkVersion !== process.env.REACT_APP_NETWORK_ID) {
        enqueueSnackbar("Connect error \nDo the following\n■PC :\nDownload a wallet such as Metamask\n■Smartphone :\nDownload the wallet's\n smartphone app > Open the app >\n Open eartha.org via the browser in the app >\n Click on the \"Buy\" button", {
          variant: 'error',
          persist: true,
          style: { whiteSpace: 'pre-line' },
          action: key => (
            <Fragment>
              <IconButton onClick={() => { closeSnackbar(key) }}>
                <CloseIcon />
              </IconButton>
            </Fragment>
          )
        })
        setBackdrop(false)
        return
      }
      const _accounts = await web3.eth.getAccounts();

      const networkId = await web3.eth.net.getId();
      const deployedNetwork = PreSales.networks[networkId];
      const _instance = new web3.eth.Contract(
        PreSales.abi,
        deployedNetwork && deployedNetwork.address,
      );

      setAccounts(_accounts)
      setSales(_instance)
      enqueueSnackbar("Connect", { variant:'success'})
    } catch (error) {
      enqueueSnackbar("Connect error \nDo the following\n■PC :\nDownload a wallet such as Metamask\n■Smartphone :\nDownload the wallet's\n smartphone app > Open the app >\n Open eartha.org via the browser in the app >\n Click on the \"Buy\" button", {
        variant: 'error',
        persist: true,
        style: { whiteSpace: 'pre-line' },
        action: key => (
          <Fragment>
            <IconButton onClick={() => { closeSnackbar(key) }}>
              <CloseIcon />
            </IconButton>
          </Fragment>
        )
      })
    }
    setBackdrop(false)
    onConnectClose()
  };
  const connectWeb3 = async () => {
    setOpenConnect(true)
  }

  const onConnectClose = () => {
    setOpenConnect(false)
  }
  initReader()
  return (
    <Container component="main">
      <Container className={classes.paper}>
        <TokenSalesHeader readSales={readSales} config={config} />
        <BuyToken sales={sales} accounts={accounts} onConnect={connectWeb3} readSales={readSales} config={config} setBackdrop={setBackdrop}  />
        {/* <WithdrawTokens sales={sales} accounts={accounts} onConnect={connectWeb3} /> */}
        {/* <RefundTokens sales={sales} accounts={accounts} onConnect={connectWeb3} /> */}
      </Container>
      <Paper className={classes.footer}>
        <Typography variant="h6">
          <Link href="#" onClick={() => readSales && setSalesInfoDialog(true)}>PreSale Information &gt;</Link>
        </Typography>
        {/* <Typography variant="h6">
          <Link href="#" onClick={() => readSales && setBalanceDialog(true)}>Your Balance &gt;</Link>
        </Typography>
        <Typography variant="h6">
          <Link href="#" onClick={() => readSales && setWithdrawDialog(true)}>Withdraw EAR &gt;</Link>
        </Typography>
        <Typography variant="h6">
          <Link href="#" onClick={() => readSales && setRefundDialog(true)}>Refund BNB &gt;</Link>
        </Typography> */}
      </Paper>
      {/* <Link href="https://eartha.org/">
        To official &gt;
      </Link> */}
      <Dialog
        open={openSalesInfoDialog}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent
          className={classes.dialogContent}>
          <TokenSalesInfo readSales={readSales} config={config} />
        </DialogContent>
        <DialogActions>
          <div style={{ flex: '1 0 0' }} />
          <Button onClick={handleClose} variant="outlined" >
            Close
          </Button>
          <div style={{ flex: '1 0 0' }} />
        </DialogActions>
      </Dialog>
      <Dialog
        open={openBalanceDialog}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent
          className={classes.dialogContent}>
          <BalanceTokens readSales={readSales} accounts={accounts} onConnect={connectWeb3} />
        </DialogContent>
        <DialogActions>
          <div style={{ flex: '1 0 0' }} />
          <Button onClick={handleClose} variant="outlined" >
            Close
          </Button>
          <div style={{ flex: '1 0 0' }} />
        </DialogActions>
      </Dialog>
      <Dialog
        open={openWithdrawDialog}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent
          className={classes.dialogContent}>
          <WithdrawTokens sales={sales} accounts={accounts} onConnect={connectWeb3} readSales={readSales} config={config} />
        </DialogContent>
        <DialogActions>
          <div style={{ flex: '1 0 0' }} />
          <Button onClick={handleClose} variant="outlined" >
            Close
          </Button>
          <div style={{ flex: '1 0 0' }} />
        </DialogActions>
      </Dialog>
      <Dialog
        open={openRefundDialog}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent
          className={classes.dialogContent}>
          <RefundTokens sales={sales} accounts={accounts} onConnect={connectWeb3} readSales={readSales} config={config} />
        </DialogContent>
        <DialogActions>
          <div style={{ flex: '1 0 0' }} />
          <Button onClick={handleClose} variant="outlined" >
            Close
          </Button>
          <div style={{ flex: '1 0 0' }} />
        </DialogActions>
      </Dialog>
      <Backdrop className={classes.backdrop} open={backdrop}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Dialog
        open={openConnect}
        onClose={onConnectClose}
        fullWidth={true}
        maxWidth={"xs"}
      >
        <DialogTitle disableTypography style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}>
          <Typography variant="h6">
            Connect Wallet
          </Typography>
          <IconButton onClick={onConnectClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <List disablePadding={true} className={classes.connectWalletList}>
          <ListItem button onClick={connectWeb3ByMetaMask}>
            <ListItemText
              primary="MetaMask"
              primaryTypographyProps={{ variant: "h6" }}
            />
            <ListItemIcon style={{ minWidth: 32 }}>
              <Icon style={{ minWidth: 32, minHeight: 32 }}>
                <img src="./assets/metamask.svg" height={32} width={32} />
              </Icon>
            </ListItemIcon>
          </ListItem>
          <ListItem button onClick={connectWeb3ByWalletConnect}>
            <ListItemText
              primary="WalletConnect"
              primaryTypographyProps={{ variant: "h6" }}
            />
            <ListItemIcon style={{ minWidth: 32 }}>
              <Icon style={{ minWidth: 32, minHeight: 32 }}>
                <img src="./assets/walletconnect.svg" height={32} width={32} />
              </Icon>
            </ListItemIcon>
          </ListItem>
          {/* <ListItem button onClick={connectWeb3ByIjected}>
            <ListItemText
              primary="TrustWallet"
              primaryTypographyProps={{ variant: "h6" }}
            />
            <ListItemIcon style={{ minWidth: 32 }}>
              <Icon style={{ minWidth: 32, minHeight: 32 }}>
                <img src="./assets/TW.svg" height={32} width={32} />
              </Icon>
            </ListItemIcon>
          </ListItem> */}
        </List>
      </Dialog>
    </Container>
  )
}


class App extends Component {
  theme = createTheme({
    typography: {
      button: {
        textTransform: "none"
      },
      // fontSize: 16,
    },
    props: {
      MuiCheckbox: {
        color: "primary"
      },
      MuiRadio: {
        color: "primary"
      },
      MuiSwitch: {
        color: "primary"
      },
      MuiList: {
        dense: true
      },
      MuiTable: {
        size: "small"
      },
      MuiTextField: {
        variant: "outlined"
      }
    },
    mixins: {
      toolbar: {
        minHeight: 42
      }
    },
    palette: {
      type: "dark",
      primary: {
        main: '#3abaff',
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 590,
        md: 600,
        lg: 600,
        xl: 600,
      },
    },
  });

  render() {
    return (
      <IntlProvider locale={navigator.language} messages={message(navigator.language)}>
        <ThemeProvider theme={this.theme}>
          <SnackbarProvider
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            maxSnack={3}
            dense
            onEnter={(x) => console.log(x)}
            preventDuplicate
          >
            <AppBar>
              {process.env.REACT_APP_NETWORK_ID !== "56" &&
                <Toolbar style={{ minHeight: "inherit", backgroundColor: "orange" }}>
                  Testnet
                </Toolbar>
              }
            </AppBar>
            <CssBaseline />
            <Root />
          </SnackbarProvider>
        </ThemeProvider>
      </IntlProvider>
    );
  }
}

export default App;
